export default class FAQ {
  constructor() {
    this.$questions = document.querySelectorAll('.c-faq__question');
    this.$questions.forEach(question => this.setupQuestion(question));
    this.activeClass = 'is-active';
  }

  /**
   * @function setupQuestion
   * @param {HTMLDivElement} question
   */
  setupQuestion(question) {
    const button = question.querySelector('.c-faq__question-title');

    button.addEventListener('click', (e) => {
      e.preventDefault();
      question.classList.toggle(this.activeClass);
    });
  }
}
